module.exports = __webpack_public_path__ + "static/media/restart.2ac26d0c.png";